module.exports = __webpack_public_path__ + "static/media/logo.b56dea22.png";